module.exports = __webpack_public_path__ + "img/05_Betonsarkophag_iPad_L.9a386cb4.jpg";